export default class MemberService {
  constructor(logger, eventBus, store, dao) {
    this.logger = logger;
    this.eventBus = eventBus;
    this.store = store;
    this.dao = dao;

    this.eventBus.on(this.eventBus.EVENT_MEMBER_UPDATED, data => this.handleMemberUpdated(data));
  }

  handleMemberUpdated(data) {
    this.logger.log('Saving member data', data._body);  // eslint-disable-line
    return this.updateMember(data._body, false);  // eslint-disable-line
  }

  async updateMember(data, sync = true) {
    this.store.commit('loadMember', data);
    if (sync) {
      return this.syncMember();
    }
    return true;
  }

  async syncMember() {
    return this.dao.updateMember(this.store.getters.loggedInMember);
  }

  biometricsSet() {
    return this.store.state.user.height !== null
      && this.store.state.user.weight !== null;
  }

  getMemberById(memberId) {
    let member;

    // Is it the current user?
    if (this.store.getters.user && this.store.getters.user.memberId === memberId) {
      member = this.store.getters.user;
    } else {
      // Is it a followee?
      member = this.store.getters.followees.find(item => item.memberId === memberId);
    }

    return member;
  }

  getMembersWithTeamSelectedInfoCopy() {
    function customizer(value) {
      const props = {
        individualSelected: false,
        groupSelected: false,
      };
      return Object.assign({}, value, props);
    }

    return this.store.getters.followees.map(member => customizer(member));
  }

  // eslint-disable-next-line
  isAthleteType(member) {
    if (!member || !member.memberType) {
      return false;
    }
    return member.memberType === 'Athlete';
  }

  // eslint-disable-next-line
  isTrainerType(member) {
    if (!member || !member.memberType) {
      return false;
    }

    return member.memberType === 'Trainer' || member.memberType === 'Coach';
  }
}
